import React, { useEffect, useRef, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "./ProfileImage.css";

const ProfileImage = ({ imgUrl, alt = "profile image" }) => {
    const fullscreenRef = useRef(null);
    const openedFromHistoryRef = useRef(false);
    const [isOpen, setIsOpen] = useState(false);

    const openFullscreen = async () => {
        setIsOpen(true);

        if (!openedFromHistoryRef.current) {
            window.history.pushState({ profileImageFullscreen: true }, "");
            openedFromHistoryRef.current = true;
        }
    };

    const closeFullscreen = async (e, fromPopState = false) => {
        if (e) e.stopPropagation();

        setIsOpen(false);

        if (!fromPopState && openedFromHistoryRef.current) {
            openedFromHistoryRef.current = false;
            window.history.back();
        }
    };

    useEffect(() => {
        const handlePopState = () => {
            if (isOpen) {
                openedFromHistoryRef.current = false;
                setIsOpen(false);
            }
        };

        window.addEventListener("popstate", handlePopState);
        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [isOpen]);

    return (
        <>
            <div className="ProfileImage" onClick={openFullscreen}>
                <LazyLoadImage src={imgUrl} alt={alt} loading="lazy" />
            </div>

            {isOpen && (
                <div
                    ref={fullscreenRef}
                    className="profile-image-fullscreen"
                    onClick={(e) => closeFullscreen(e)}
                >
                    <button
                        className="profile-image-close"
                        type="button"
                        onClick={(e) => closeFullscreen(e)}
                    >
                        ×
                    </button>

                    <img
                        src={imgUrl}
                        alt={alt}
                        className="profile-image-fullscreen-img"
                    />
                </div>
            )}
        </>
    );
};

export default ProfileImage;